// extracted by mini-css-extract-plugin
module.exports = {"spFrame":"PreviewFrame_spFrame__1EKIH","spFrame__inner":"PreviewFrame_spFrame__inner__3HMZi"};